<app-header-layout>
  <app-page [padding]="'p-0'" class="bg-gradient-to-b from-25% from-white to-85% to-gray-lighten">
    <mat-tab-group (selectedIndexChange)="onTabIndexChange($event)">
      <mat-tab>
        <ng-template mat-tab-label>
          <p class="text-tab">My Friends</p>
        </ng-template>
        <app-friends-list [tabUpdated]="tabUpdated()"></app-friends-list>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex">
            <p class="text-tab">My Contacts</p>
          </div>
        </ng-template>
        <app-my-contacts-list [tabUpdated]="tabUpdated()"></app-my-contacts-list>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex">
            <p class="text-tab">Requests</p>
            @if (requestTotal()) {
              <app-badge class="bg-yellow font-medium">{{ friendsService.getRequestTotal() }}</app-badge>
            }
          </div>
        </ng-template>
        <app-requests-list [tabUpdated]="tabUpdated()"></app-requests-list>
      </mat-tab>
    </mat-tab-group>
  </app-page>
</app-header-layout>
